import * as React from 'react';

export type Props = {
	name: string
	content: ()=>React.ReactNode
	ready?: boolean
	loading?: boolean
	action?: Function

	// Hardcode some actions to be used depending on the key
	getCountries?: Function
	getFabrics?: Function
	getUserCart?: Function
}

export default class Prerequisite extends React.Component<Props> {
	componentDidMount() {
		if(this.props.loading || this.props.ready) return;
		const action = this.getAction();
		if(action) action();
	}

	private getAction() {
		if(this.props.action) return this.props.action;
		switch(this.props.name){
			case "countries":
				return this.props.getCountries;
			case "fabrics":
				return this.props.getFabrics;
			case "cart":
				return this.props.getUserCart;
		}
		return null;
	}

	render = () => {
		if(this.props.loading || (typeof this.props.ready !== 'undefined' && !this.props.ready)) return <></>
		return <>{this.props.content()}</>
	}
}